module.exports = __webpack_public_path__ + "static/media/descending.323a27c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/descending.svg
// module id = 756
// module chunks = 0